import store from '../store';

export default function canAddEdit({ next, router }) {
  const roles = ['owner', 'editor'];
  const userRoles = store.getters['roles/roles'];
  const observed = store.getters['observed/observed'];
  if (observed.roles[0] !== 'owner' || !userRoles.some(v => roles.includes(v))) {
    return router.go(-1);
  }

  return next();
}